// BUTTON
export interface Button {
  cta: string;
  label: string;
  color?: MuiButtonColor;
}

export type MuiButtonColor = "primary" | "inherit" | "secondary" | "success" | "error" | "info" | "warning";

// FUNCTIONS
export type VoidFunction = (ev?: any) => void;

// INPUT
export enum InputType {
  TEXT = "text",
  NUMBER = "number",
  TEXTAREA = "textarea",
  FILE = "file",
  SELECT = "select",
  DATE = "date",
  TIME = "time",
  PHONE = "phone",
  PASSWORD = "password",
}

export interface SelectOption {
  label: string;
  id: string;
}

export interface InputMap {
  inputMap: {
    [key: string]: { inputs: Input[]; href: string };
  };
  mapSelectLabel: string;
}

export interface Input {
  label?: string;
  options?: SelectOption[];
  placeholder?: string;
  type: InputType;
  name: string;
  optional?: boolean;
  step?: number;
  min?: number;
  max?: number;
  pattern?: string;
}
